export const BYTE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB'];
export const DEFAULT_ROWS_PER_PAGE = 5;
export const ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 25];
